import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { EMPLOYEE_BLUE, PINK_RED, WHITE } from "../colors";
import HeightBox from "./HeightBox";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 721,
  height: 280,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  bgcolor: "#E1DEDE",
  boxShadow: 24,
  p: 4,
};

const CustomButton = styled(Button)(({ theme }) => ({
  height: 40,
  minWidth: 180,
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
  color: WHITE,
}));

export default function CustomModelForResign(props) {
  const { message, okFunction, cancelFunction, openModel, handleCancelModel } =
    props;

  return (
    <Modal
      open={openModel}
      onClose={handleCancelModel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <IconButton
          aria-label="delete"
          onClick={cancelFunction}
          sx={{ position: "absolute", right: "20px", top: "20px" }}
        >
          <CloseIcon />
        </IconButton>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {message}
        </Typography>
        <HeightBox height={40} />
        <Stack direction="row" alignItems="center" spacing={3}>
          <CustomButton
            style={{ backgroundColor: PINK_RED }}
            onClick={okFunction}
          >
            yes
          </CustomButton>
          <CustomButton
            style={{ backgroundColor: EMPLOYEE_BLUE }}
            onClick={cancelFunction}
          >
            no
          </CustomButton>
        </Stack>
      </Box>
    </Modal>
  );
}
